import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useMessage } from 'naive-ui'
import { useAuthStore } from '@/stores/auth-store'

export function useAuthGuard() {
  const router = useRouter()
  const authStore = useAuthStore()
  const message = useMessage()

  onMounted(() => {
    if (!authStore.isLoggedIn) {
      message.warning('请先登录')
      router.replace('/my')
    }
  })

  return { isLoggedIn: authStore.isLoggedIn }
}
